"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DrawSearchLayer = exports.initialState = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _throttle2 = _interopRequireDefault(require("lodash/throttle"));

var _drawSearchUtils = require("../util/drawSearchUtils");

var _mapPositionUtils = require("../util/mapPositionUtils");

var _constants = require("../util/constants");

var _DrawSearchBoundary = _interopRequireDefault(require("../BoundaryManager/DrawSearchBoundary"));

var _ZillowMapContext = _interopRequireDefault(require("../ZillowMapContext"));

var _DrawSearchActionBar = _interopRequireDefault(require("./DrawSearchActionBar"));

var _jsxFileName = "/builds/zillow/searchxp/zillow-map-control/src/DrawSearch/ZillowMapDrawSearchLayer.jsx";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint global-require: 0 import/first: 0 */
if (typeof window !== 'undefined') {
  require("whatwg-fetch");
}

var mapContextToProps = function mapContextToProps(props) {
  return _react.default.createElement(_ZillowMapContext.default.Consumer, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30
    },
    __self: this
  }, function (contextData) {
    if (contextData.gmap) {
      return _react.default.createElement(DrawSearchLayer, _extends({}, props, {
        gmap: contextData.gmap,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 34
        },
        __self: this
      }));
    }

    return null;
  });
};

var initialState = {
  newPolygon: [],
  polygons: [],
  drawing: false
};
exports.initialState = initialState;

var DrawSearchLayer =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(DrawSearchLayer, _PureComponent);

  function DrawSearchLayer(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    (0, _reactAutobind.default)(_assertThisInitialized(_this));
    _this.state = initialState;
    _this.mouseMoveListener = null;
    _this.mouseUpListener = null;
    _this.mouseDownListener = null;
    _this.topOffset = 0;
    _this.newPolygonContainerRef = _react.default.createRef();
    _this.throttledUpdateTopOffset = (0, _throttle2.default)(_this.updateTopOffset);

    if (props.onCustomRegionSubmit && props.customRegionEndpoint !== DrawSearchLayer.defaultProps.customRegionEndpoint) {
      console.warn('customRegionEndpoint and onCustomRegionSubmit are both being provided to ZillowMapDrawSearchLayer. If onCustomRegionSubmit is provided, customRegionEndpoint will not be used.');
    }

    return _this;
  }

  var _proto = DrawSearchLayer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mouseMoveListener = this.props.gmap.addListener('mousemove', this.onMouseMove);
    this.mouseDownListener = google.maps.event.addDomListener(this.props.gmap, 'mousedown', this.onMouseDown);
    this.mouseUpListener = google.maps.event.addDomListener(this.props.gmap, 'mouseup', this.onMouseUp);
    var mapDiv = this.props.gmap.getDiv();
    mapDiv.addEventListener('touchstart', this.onTouchStart);
    mapDiv.addEventListener('touchmove', this.onTouchMove);
    mapDiv.addEventListener('touchend', this.onTouchEnd); // This is to prevent iOS Safari from over scrolling the window when we are drawing.

    window.addEventListener('touchmove', this.stopWindowTouchEvents, {
      passive: false
    });

    if (this.newPolygonContainerRef.current) {
      var current = this.newPolygonContainerRef.current;
      current.addEventListener('resize', this.throttledUpdateTopOffset);
      this.topOffset = current.getBoundingClientRect().top;
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    google.maps.event.removeListener(this.mouseMoveListener);
    google.maps.event.removeListener(this.mouseUpListener);
    google.maps.event.removeListener(this.mouseDownListener);
    var mapDiv = this.props.gmap.getDiv();
    mapDiv.removeEventListener('touchstart', this.onTouchStart);
    mapDiv.removeEventListener('touchmove', this.onTouchMove);
    mapDiv.removeEventListener('touchend', this.onTouchEnd);
    window.removeEventListener('touchmove', this.stopWindowTouchEvents);
    this.newPolygonContainerRef.current.removeEventListener('resize', this.throttledUpdateTopOffset);

    if (typeof window !== 'undefined') {
      // this should have been cleaned up in mouse up, but just incase that has not happened
      // deleting here will prevent memory leak.
      // eslint-disable-next-line no-underscore-dangle
      delete window._drawSearchMoveTestHook;
    }
  };

  _proto.onMouseDown = function onMouseDown() {
    var _this2 = this;

    this.setState({
      drawing: true
    });

    if (typeof window !== 'undefined') {
      // Creating hook to active draw layer so test automation can bypass google
      // and insert move events to draw a search region.
      // eslint-disable-next-line no-underscore-dangle
      window._drawSearchMoveTestHook = function (ev) {
        return _this2.onMouseMove(ev, false);
      };
    }
  };

  _proto.onMouseMove = function onMouseMove(ev, isTouchEvent) {
    if (this.isTouchDrawing && !isTouchEvent) {
      return;
    }

    if (this.state.drawing) {
      this.setState(function (currentState) {
        return {
          newPolygon: [].concat(_toConsumableArray(currentState.newPolygon), [ev.pixel.x, ev.pixel.y])
        };
      });
    }
  };

  _proto.onMouseUp = function onMouseUp() {
    if (this.state.drawing && this.state.newPolygon.length > 6) {
      this.setState(function (currentState) {
        return {
          drawing: false,
          newPolygon: [],
          polygons: [].concat(_toConsumableArray(currentState.polygons), [{
            id: (0, _drawSearchUtils.generateRandomId)(),
            poly: (0, _drawSearchUtils.finishPolygon)(currentState.newPolygon, _constants.DEFAULT_POLYGON_PIXEL_TOLERANCE)
          }])
        };
      });
    } else if (this.state.drawing) {
      this.setState({
        drawing: false,
        newPolygon: []
      });
    }
  }
  /*
      iOS9 won't fire mouse events so we have to listen to touch events instead. If they are fired
      we call the mouse events. Some browsers will fire both so we need to account for that. The
      reason we don't just use touch events is because it is not supported by all browsers.
   */
  ;

  _proto.onTouchStart = function onTouchStart() {
    this.isTouchDrawing = true;
    this.onMouseDown();
  };

  _proto.onTouchMove = function onTouchMove(e) {
    var _e$touches = _slicedToArray(e.touches, 1),
        touch = _e$touches[0];

    var offsetY = touch.clientY - this.topOffset;
    this.onMouseMove({
      pixel: {
        x: touch.clientX,
        y: offsetY
      }
    }, true);
  };

  _proto.onTouchEnd = function onTouchEnd() {
    this.isTouchDrawing = false;
    this.onMouseUp();
  } // We want this to be be a per instance method for the sake of unique listener registering.
  // eslint-disable-next-line class-methods-use-this
  ;

  _proto.stopWindowTouchEvents = function stopWindowTouchEvents(e) {
    e.preventDefault();
  };

  _proto.updateTopOffset = function updateTopOffset() {
    this.topOffset = this.newPolygonContainerRef.current.getBoundingClientRect().top || 0;
  };

  _proto.submitNewCustomRegion = function submitNewCustomRegion() {
    var _this3 = this;

    // The custom region endpoint expects polygons to be in lat/lng so we need to convert them
    // before submitting
    var latLngPolygons = this.state.polygons.map(function (polygon) {
      return polygon.poly.reduce(function (accu, point, index, array) {
        if (index % 2 === 0) {
          var screenX = array[index];
          var screenY = array[index + 1];
          var latLng = (0, _mapPositionUtils.convertScreenXYToLatLng)(screenX, screenY, _this3.props.gmap);
          return [].concat(_toConsumableArray(accu), [latLng.lat(), latLng.lng()]);
        }

        return accu;
      }, []);
    });

    (function () {
      return new Promise(function ($return, $error) {
        var formData, rawResponse, jsonResponse;

        var $Try_3_Post = function () {
          try {
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        };

        var $Try_3_Catch = function (e) {
          try {
            if (_this3.props.onCustomRegionSubmitFail) {
              _this3.props.onCustomRegionSubmitFail(e);
            }

            return $Try_3_Post();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        };

        try {
          if (_this3.props.onCustomRegionSubmit) {
            return Promise.resolve(_this3.props.onCustomRegionSubmit(latLngPolygons)).then(function ($await_5) {
              try {
                _this3.props.onCustomRegionSubmitSuccess(null, latLngPolygons);

                return $If_4.call(this);
              } catch ($boundEx) {
                return $Try_3_Catch($boundEx);
              }
            }.bind(this), $Try_3_Catch);
          } else {
            formData = new FormData();
            formData.append('clipPolygon', (0, _drawSearchUtils.formatCustomRegionPayload)(latLngPolygons));
            return Promise.resolve(fetch(_this3.props.customRegionEndpoint, {
              method: 'POST',
              body: formData
            })).then(function ($await_6) {
              try {
                rawResponse = $await_6;
                return Promise.resolve(rawResponse.json()).then(function ($await_7) {
                  try {
                    jsonResponse = $await_7;

                    _this3.props.onCustomRegionSubmitSuccess(jsonResponse.customRegionId, latLngPolygons);

                    return $If_4.call(this);
                  } catch ($boundEx) {
                    return $Try_3_Catch($boundEx);
                  }
                }.bind(this), $Try_3_Catch);
              } catch ($boundEx) {
                return $Try_3_Catch($boundEx);
              }
            }.bind(this), $Try_3_Catch);
          }

          function $If_4() {
            _this3.setState(initialState);

            return $Try_3_Post();
          }
        } catch (e) {
          $Try_3_Catch(e)
        }
      });
    })();
  };

  _proto.cancelDrawSearch = function cancelDrawSearch() {
    this.setState(initialState);
    this.props.onCustomRegionCancel();
  };

  _proto.renderNewPolygon = function renderNewPolygon() {
    return _react.default.createElement("div", {
      className: "full-boundary-container",
      ref: this.newPolygonContainerRef,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 252
      },
      __self: this
    }, _react.default.createElement("svg", {
      className: "full-boundary-svg",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 253
      },
      __self: this
    }, this.state.newPolygon.length > 0 && _react.default.createElement("path", {
      key: "new-polygon",
      className: "poly-region",
      style: {
        fill: 'none'
      },
      d: (0, _mapPositionUtils.getPathLineFromCoordinateArray)(this.state.newPolygon),
      __source: {
        fileName: _jsxFileName,
        lineNumber: 255
      },
      __self: this
    })));
  };

  _proto.renderActionBar = function renderActionBar() {
    if (this.props.customActionBar) {
      return _react.default.cloneElement(this.props.customActionBar, {
        onCancel: this.cancelDrawSearch,
        onApply: this.submitNewCustomRegion
      });
    }

    return _react.default.createElement(_DrawSearchActionBar.default, {
      onCancel: this.cancelDrawSearch,
      onApply: this.submitNewCustomRegion,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 279
      },
      __self: this
    });
  };

  _proto.render = function render() {
    var style = {
      pointerEvents: 'none'
    };
    return _react.default.createElement("div", {
      style: style,
      className: "zillow-map-layer draw-search-layer",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 292
      },
      __self: this
    }, _react.default.createElement("div", {
      className: "zillow-map-draw-overlay",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 295
      },
      __self: this
    }, this.renderActionBar(), _react.default.createElement("div", {
      className: "zillow-map-draw-custom-overlay",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 297
      },
      __self: this
    }, this.props.customOverlay)), this.renderNewPolygon(), _react.default.createElement(_DrawSearchBoundary.default, {
      polygons: this.state.polygons.map(function (polygon) {
        return polygon.poly;
      }),
      __source: {
        fileName: _jsxFileName,
        lineNumber: 302
      },
      __self: this
    }));
  };

  return DrawSearchLayer;
}(_react.PureComponent);

exports.DrawSearchLayer = DrawSearchLayer;
DrawSearchLayer.propTypes = process.env.NODE_ENV !== "production" ? {
  gmap: _propTypes.default.shape({
    addListener: _propTypes.default.func,
    getDiv: _propTypes.default.func
  }).isRequired,

  /**
   * A custom submit handler. Providing a function here will prevent the default submit handling
   * from happening. Instead, this function will be called and provided the lat/lng polygons.
   *
   * If a promise is returned by this function, onCustomRegionSubmitSuccess and
   * onCustomRegionSubmitFail will be called depending on the outcome of that promise.
   *
   * No customRegionId will be provided to onCustomRegionSubmitSuccess, only the lat/lng polygons.
   */
  onCustomRegionSubmit: _propTypes.default.func,
  onCustomRegionSubmitSuccess: _propTypes.default.func,
  onCustomRegionSubmitFail: _propTypes.default.func,
  onCustomRegionCancel: _propTypes.default.func,
  customRegionEndpoint: _propTypes.default.string,
  customActionBar: _propTypes.default.node,
  customOverlay: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
} : {};
DrawSearchLayer.defaultProps = {
  onCustomRegionSubmit: null,
  onCustomRegionSubmitSuccess: function onCustomRegionSubmitSuccess() {},
  onCustomRegionSubmitFail: function onCustomRegionSubmitFail() {},
  onCustomRegionCancel: function onCustomRegionCancel() {},
  customRegionEndpoint: '/search/GetSearchPageCustomRegion.htm',
  customActionBar: null,
  customControlElements: null,
  customOverlay: null
};
var _default = mapContextToProps;
exports.default = _default;